// extracted by mini-css-extract-plugin
module.exports = {"base":"YAqWn4","accordionItemHeader":"_1KTjwe","active":"_2lDZcL"};